"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GpsResponse = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const rxjs_1 = require("../../../../hooks/rxjs");
const operators_1 = require("rxjs/operators");
const room_session_1 = require("../../../../context/room_session");
const domain_id_1 = require("@streem/domain-id");
const ui_react_1 = require("@streem/ui-react");
const request_1 = require("./request");
const location_blocked_1 = require("./location_blocked");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
function GpsResponse() {
    const [open, setOpen] = (0, react_1.useState)(false);
    const [rejected, setRejected] = (0, react_1.useState)(false);
    const gpsIdsToIgnore = (0, react_1.useRef)([]);
    const [awaitingResponse, setAwaitingResponse] = (0, react_1.useState)(false);
    const roomSession = (0, room_session_1.useRoomSession)();
    const [remoteUser] = (0, rxjs_1.useObservable)(roomSession.user.remoteUser);
    // TODO: fix eslint error be wrapping in useMemo: https://streempro.atlassian.net/browse/ST-3779
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const gpsId = new domain_id_1.GpsId();
    const [gpsRequest] = (0, rxjs_1.useObservable)(roomSession.geolocation.requests.pipe((0, operators_1.map)(requests => requests[requests.length - 1])));
    const [gpsResponse] = (0, rxjs_1.useObservable)(roomSession.geolocation.responses.pipe((0, operators_1.map)(responses => responses[responses.length - 1]), (0, operators_1.filter)(response => { var _a; return !gpsIdsToIgnore.current.includes((_a = response === null || response === void 0 ? void 0 : response.inResponseToWallItemId) !== null && _a !== void 0 ? _a : ''); })));
    const latestResponseStatus = gpsResponse === null || gpsResponse === void 0 ? void 0 : gpsResponse.status;
    const responseStatusRef = (0, react_1.useRef)(latestResponseStatus);
    const latestResponseId = gpsResponse === null || gpsResponse === void 0 ? void 0 : gpsResponse.inResponseToWallItemId;
    const responseIdRef = (0, react_1.useRef)(latestResponseId);
    const latestRequestId = gpsRequest === null || gpsRequest === void 0 ? void 0 : gpsRequest.artifactId;
    const requestIdRef = (0, react_1.useRef)(latestRequestId);
    (0, react_1.useEffect)(() => {
        if (responseIdRef.current !== latestResponseId) {
            responseStatusRef.current = latestResponseStatus;
            responseIdRef.current = latestResponseId;
            setAwaitingResponse(false);
        }
        if (!awaitingResponse) {
            const rejected = responseStatusRef.current === streem_sdk_protobuf_1.WallItem.Artifact.Status.REJECTED;
            setOpen(rejected);
            setRejected(rejected);
        }
    }, [latestResponseStatus, latestResponseId, awaitingResponse]);
    (0, react_1.useEffect)(() => {
        if (requestIdRef.current !== latestRequestId) {
            requestIdRef.current = latestRequestId;
            if (typeof latestRequestId !== 'undefined') {
                setOpen(true);
            }
        }
    }, [latestRequestId]);
    const fulfill = (0, react_1.useCallback)(() => {
        if (latestRequestId) {
            roomSession.geolocation.fulfillGeolocation(gpsId, latestRequestId);
            setOpen(false);
        }
    }, [latestRequestId, gpsId, roomSession.geolocation]);
    const dismiss = () => {
        setAwaitingResponse(false);
        setOpen(false);
        setRejected(false);
    };
    const reject = (0, react_1.useCallback)(() => {
        if (latestRequestId) {
            gpsIdsToIgnore.current.push(latestRequestId);
            roomSession.geolocation.rejectGeolocation(gpsId, latestRequestId);
            setOpen(false);
        }
    }, [latestRequestId, gpsId, roomSession.geolocation]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: open && ((0, jsx_runtime_1.jsxs)(PopoutContainer, { children: [rejected && (0, jsx_runtime_1.jsx)(location_blocked_1.LocationBlocked, { dismiss: dismiss }), !rejected && ((0, jsx_runtime_1.jsx)(request_1.Request, { fulfill: fulfill, reject: reject, remoteUserName: remoteUser === null || remoteUser === void 0 ? void 0 : remoteUser.name }))] })) }));
}
exports.GpsResponse = GpsResponse;
const PopoutContainer = ui_react_1.styled.div `
    z-index: ${({ theme }) => theme.layers.modal};
    height: 100%;
    align-items: center;
    margin: 0 auto;
    padding: 2.5vw;
    display: flex;
`;
//# sourceMappingURL=gps_response.js.map